
export const supportUserListGet = (data) => {
    return data.data
}

export const hotelListGet = (data) => {
    return data.data
}

export const supportCreatePost = (data) => {
    return data.data
}

export const supportCreateUpdate = (data) => {
    return data.data
}
export const assignBusinessListGet = (data) => {
    return data.data
}
export const auditHistoryListGet = (data) => {
    return data.data
}
export const supportUserUpdateGet = (data) => {
    return data.data
}
export const branchListGet = (data) => {
    return data.data
}

